import { useMemo, useState } from 'react';
import { PaginationResultSizes } from '@types';

export const useLevelPagination = (initialPage?: number, initialPageSize?: number) => {
  const [page, setPage] = useState(initialPage ?? 0);
  const [size, setSize] = useState(initialPageSize ?? PaginationResultSizes[0]);
  const pagination = useMemo(
    () => ({
      page,
      setPage,
      size,
      setSize,
    }),
    [page, size]
  );

  return pagination;
};
